import { BubbleType } from '../../../../../component/bubble-text/bouble-text';
import React, { useEffect, useState } from 'react';
import AddEditTaskDialog from './components/add-new-task/add-edit-task.dialog';
import { Dialog } from 'primereact/dialog';
import { DataTable, DataTableRowClickEvent } from 'primereact/datatable';
import { Column } from 'primereact/column';
import dateFormat from '../../../../../utils/date-format';
import TaskGrades from './components/task-grades';
import TaskIcon from '../../../../../assets/icons/icon-doc-green.svg';
import { Button } from 'primereact/button';
import { SessionHeaderItem } from '../../exams/components/exam-page/session-header/componenets/session-header-item';
import dateUtils from '../../../../../utils/date-format';
import { TaskPageDialog } from './components/task-page-dialog/task-page-dialog';
import { ExamSessionFile } from '../../../../../api/types/programs/course/exams/response/exam-metadata';
import globalProgramStore from '../../../../../stores/program-store';
import globalCourseStore from '../../../../../stores/global-course-store';
import { deleteAssignmentIdOperation } from './operations/delete-assignment-id.operation';

export interface taskItemModel {
  id: number;
  taskName: string;
  dueDate: Date;
  percent: number;
  fileName?: string;
  fileUrl?: string;
  bubbleText: string;
  bubbleCallBack: (index: number) => void;
  bubbleType: BubbleType;
  isGradesPublished: boolean;
  averageGrade: number | null;
}

export interface TaskSectionDataModel {
  tasks: taskItemModel[];
  onTaskSelected: (index: number) => void;
}

const TasksSection: React.FC<TaskSectionDataModel> = ({
  tasks,
  onTaskSelected,
}) => {
  const [displayAddTaskDialog, setDisplayAddTaskDialog] = useState(false);
  const [selectedAssignmentId, setSelectedAssignmentId] = useState<
    taskItemModel | undefined
  >(undefined);

  useEffect(() => {
    const currentSelectedTask = tasks.find(
      (item) => item.id === selectedAssignmentId?.id,
    );
    if (currentSelectedTask) {
      setSelectedAssignmentId(currentSelectedTask);
    }
  }, [tasks]);

  const [displayAddFile, setDisplayAddFile] = useState(false);

  const onHideDialog = () => setSelectedAssignmentId(undefined);
  const [loading, setLoading] = useState(false);
  const handleDelete = async (assignmentId: number) => {
    const currentProgramId = globalProgramStore.getCurrentId();
    const currentCourseId = globalCourseStore.getCurrentCourse()?.metadata.id;

    await deleteAssignmentIdOperation(
      currentProgramId,
      currentCourseId,
      assignmentId,
      setLoading,
    );
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <img src={TaskIcon} />
          <div
            style={{
              color: '#041E49',
              fontSize: '16px',

              marginRight: '8px',
            }}
          >
            מטלות
          </div>
        </div>

        {/*<div>מטלות</div>*/}

        <Button
          style={{ height: '30px' }}
          label={'להוספה'}
          onClick={() => setDisplayAddTaskDialog(true)}
        />
      </div>

      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        selectionMode={'multiple'}
        multiple={true}
        groupRowsBy="dsf"
        value={tasks}
        onRowClick={(e: DataTableRowClickEvent) => {
          const assignment: taskItemModel = e.data;
          setSelectedAssignmentId(assignment);
        }}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '8px',
        }}
      >
        <Column
          style={{ textAlign: 'right' }}
          field="נשלח ע״י"
          header="שם המטלה"
          body={(rowData: taskItemModel) => <div>{rowData.taskName}</div>}
        />

        <Column
          style={{ textAlign: 'right' }}
          field="נשלח ע״י"
          header="תאריך הגשה"
          body={(rowData: taskItemModel) => (
            <div>{dateFormat.displayFormatDate(rowData.dueDate)}</div>
          )}
        />

        <Column
          style={{ textAlign: 'right' }}
          field="נשלח ע״י"
          header="אחוז מהציון הסופי"
          body={(rowData: taskItemModel) => <div>{rowData.percent}</div>}
        />

        <Column
          style={{ textAlign: 'right' }}
          field="averageGrade"
          header="ציון ממוצע"
          body={(rowData: taskItemModel) => (
            <div>
              {rowData.averageGrade !== null
                ? rowData.averageGrade
                : 'טרם הוזנו ציונים'}
            </div>
          )}
        />

        <Column
          style={{ textAlign: 'right' }}
          field="נשלח ע״י"
          header=""
          body={(rowData: ExamSessionFile) => (
            <Button
              icon="pi pi-trash"
              text
              tooltip={'לחץ למחיקת המטלה'}
              severity="danger"
              disabled={loading}
              onClick={() => handleDelete(rowData.id)}
            />
          )}
        />
      </DataTable>

      <TaskPageDialog
        selectedAssignmentId={selectedAssignmentId}
        onHide={onHideDialog}
      />

      <Dialog
        header="הוספת מטלה"
        visible={displayAddTaskDialog}
        style={{
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '8px',
        }}
        onHide={() => {
          setDisplayAddTaskDialog(false);
        }}
      >
        <AddEditTaskDialog onHide={() => setDisplayAddTaskDialog(false)} />
      </Dialog>
    </div>
  );
};

export default TasksSection;
